/* Shared product controller. No legacy OptionSelectors, recursive menus or cloned carousels. */
(function () {
  'use strict';
  if (customElements.get('serlex-product')) return;
  class SerlexProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.wide = window.matchMedia('(min-width: 1440px)');
      this.mobile = window.matchMedia('(max-width: 989px)');
      this.onClick = this.click.bind(this);
      this.onChange = this.change.bind(this);
      this.onSubmit = this.submit.bind(this);
      this.onHistory = this.history.bind(this);
      this.onMotion = this.motion.bind(this);
      this.onBarcodeResize = () => {
        cancelAnimationFrame(this.barcodeFrame);
        this.barcodeFrame = requestAnimationFrame(() => this.drawBarcodes());
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);
      window.addEventListener('popstate', this.onHistory);
      window.addEventListener('resize', this.onBarcodeResize, {passive:true});
      if (this.reduce.addEventListener) this.reduce.addEventListener('change', this.onMotion);
      else this.reduce.addListener(this.onMotion);
      this.bindBuy();
      this.classList.add('sp-enhanced');
      this.initializeModels();
      var categories = this.querySelector('[data-sp-categories]');
      if (categories && this.mobile.matches) categories.open = false;
      this.loadRelated();
    }
    disconnectedCallback() {
      this.ready = false;
      this.abort.abort();
      if (this.variantAbort) this.variantAbort.abort();
      if (this.relatedAbort) this.relatedAbort.abort();
      clearTimeout(this.relatedTimeout);
      cancelAnimationFrame(this.barcodeFrame);
      clearInterval(this.railTimer);
      if (this.observer) this.observer.disconnect();
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
      window.removeEventListener('popstate', this.onHistory);
      window.removeEventListener('resize', this.onBarcodeResize);
      if (this.reduce.removeEventListener) this.reduce.removeEventListener('change', this.onMotion);
      else this.reduce.removeListener(this.onMotion);
    }
    bindBuy() {
      this.data = JSON.parse(this.querySelector('[data-sp-product]').textContent);
      this.form = this.querySelector('.sp-form');
      this.master = this.form.querySelector('[data-sp-master]');
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.add = this.form.querySelector('[data-sp-add]');
      this.variant = this.data.variants.find(v => String(v.id) === String(this.data.selectedId));
      this.syncVariant(this.variant, false);
      if (window.SerlexFulfilment && this.data.needsConfirmation) window.SerlexFulfilment.register(this.data, this.form);
      if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
    }
    money(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var temp = document.createElement('span');
        temp.innerHTML = window.Shopify.formatMoney(Number(cents), this.data.moneyFormat);
        return temp.textContent;
      }
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.data.currency}).format(Number(cents) / 100); }
      catch (_) { return (Number(cents) / 100).toFixed(2) + ' ' + this.data.currency; }
    }
    status(text, error, basket) {
      var node = this.form.querySelector('[data-sp-status]');
      node.textContent = text || '';
      node.hidden = !text;
      node.dataset.error = error ? 'true' : 'false';
      if (basket) {
        var link = document.createElement('a');
        link.href = this.root() + 'cart';
        link.textContent = 'View basket →';
        node.appendChild(link);
      }
    }
    root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
    initializeModels() {
      var models = this.querySelectorAll('model-viewer');
      if (!models.length || !window.Shopify || !window.Shopify.loadFeatures) return;
      window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:error => {
        if (error || !this.isConnected || !window.Shopify.ModelViewerUI) return;
        models.forEach(model => { new window.Shopify.ModelViewerUI(model); });
      }}]);
    }
    click(event) {
      var button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-sp-choice')) {
        var select = this.form.querySelector('[data-sp-option-select="' + button.dataset.optionIndex + '"]');
        if (select.value === button.dataset.spChoice) return;
        select.value = button.dataset.spChoice;
        select.dispatchEvent(new Event('change', {bubbles:true}));
      } else if (button.hasAttribute('data-sp-quantity')) {
        var min = Number(this.quantity.min) || 1, step = Number(this.quantity.step) || 1;
        var max = this.quantity.max ? Number(this.quantity.max) : Infinity;
        var current = Number(this.quantity.value) || min;
        this.quantity.value = String(Math.max(min, Math.min(max, current + Number(button.dataset.spQuantity) * step)));
        this.quantity.dispatchEvent(new Event('change', {bubbles:true}));
      } else if (button.hasAttribute('data-sp-thumbnail')) {
        this.showMedia(button.dataset.spThumbnail);
      } else if (button.hasAttribute('data-sp-zoom')) {
        var dialog = this.querySelector('[data-sp-lightbox]');
        if (!dialog.showModal) { window.open(button.dataset.spZoom, '_blank', 'noopener'); return; }
        var img = dialog.querySelector('img');
        img.src = button.dataset.spZoom;
        img.alt = button.querySelector('img').alt;
        dialog.showModal();
        dialog.querySelector('button').focus();
      } else if (button.hasAttribute('data-sp-close')) {
        this.querySelector('[data-sp-lightbox]').close();
      } else if (button.hasAttribute('data-sp-barcode-open')) {
        var barcodeDialog = this.querySelector('[data-sp-barcode-dialog]');
        if (barcodeDialog && barcodeDialog.showModal && !barcodeDialog.open) { barcodeDialog.showModal(); this.drawBarcodes(); }
      } else if (button.hasAttribute('data-sp-barcode-close')) {
        this.querySelector('[data-sp-barcode-dialog]').close();
      } else if (button.hasAttribute('data-sp-rail-step')) {
        var rail = button.closest('[data-sp-rail]');
        this.pauseRail(rail, true);
        this.advanceRail(rail, Number(button.dataset.spRailStep));
      } else if (button.hasAttribute('data-sp-rail-pause')) {
        this.pauseRail(button.closest('[data-sp-rail]'), button.getAttribute('aria-pressed') !== 'true');
      }
    }
    change(event) {
      var target = event.target;
      if (target.hasAttribute('data-sp-option-select')) {
        this.status('');
        if (this.data.complete) {
          var selected = Array.from(this.form.querySelectorAll('[data-sp-option-select]')).map(select => select.value);
          this.syncVariant(this.data.variants.find(v => v.options.every((value, i) => value === selected[i])), true);
        } else this.fetchSelection();
      } else if (target === this.master) {
        var variant = this.data.variants.find(v => String(v.id) === String(this.master.value));
        if (variant) this.syncVariant(variant, true);
      } else if (target === this.quantity) {
        this.updateQuantity();
      } else if (target.hasAttribute('data-sp-plan')) {
        this.syncVariant(this.variant, false);
      } else if (target.hasAttribute('data-sp-addon') || target.hasAttribute('data-sp-addon-check')) {
        this.updateQuantity();
      }
    }
    syncVariant(variant, updateUrl) {
      this.variant = variant;
      if (variant) {
        if (!Array.from(this.master.options).some(option => option.value === String(variant.id))) this.master.add(new Option(variant.title, String(variant.id)));
        this.master.value = String(variant.id);
        this.form.querySelectorAll('[data-sp-option-select]').forEach((select, i) => { select.value = variant.options[i]; });
      } else this.master.value = '';
      var selected = Array.from(this.form.querySelectorAll('[data-sp-option-select]')).map(select => select.value);
      this.form.querySelectorAll('[data-sp-option]').forEach((field, i) => {
        field.querySelector('[data-sp-option-value]').textContent = selected[i];
        field.querySelectorAll('[data-sp-choice]').forEach(button => {
          var value = button.dataset.spChoice;
          button.setAttribute('aria-pressed', String(value === selected[i]));
          if (this.data.complete) {
            var available = this.data.variants.some(v => v.available && v.options.every((choice, j) => choice === (j === i ? value : selected[j])));
            button.dataset.unavailable = String(!available);
            button.title = available ? '' : 'Not available with the other selected options';
          }
        });
      });
      var planSelect = this.form.querySelector('[data-sp-plan]');
      var plan = planSelect && planSelect.value ? this.data.plans.find(p => String(p.variantId) === String(variant && variant.id) && String(p.id) === planSelect.value) : null;
      var validPlan = !planSelect || (!planSelect.value && !this.data.requiresPlan) || !!plan;
      var price = variant ? (plan ? plan.price : variant.price) : null;
      var compare = variant ? (plan ? plan.compare_at_price : variant.compare_at_price) : null;
      var stock = this.querySelector('[data-sp-stock]');
      stock.textContent = !variant ? 'This combination is unavailable' : !validPlan ? 'Choose a purchase option' : variant.available ? 'Available to order' : 'Sold out';
      stock.dataset.available = String(!!(variant && variant.available && validPlan));
      this.querySelector('[data-sp-price]').textContent = price === null ? 'Unavailable' : this.money(price);
      var oldPrice = this.querySelector('[data-sp-compare]');
      oldPrice.hidden = !(compare > price);
      oldPrice.textContent = compare > price ? this.money(compare) : '';
      this.querySelector('[data-sp-sale]').hidden = !(compare > price);
      var vat = this.querySelector('[data-sp-vat]');
      vat.hidden = !(variant && this.data.taxesIncluded && variant.taxable);
      if (!vat.hidden) {
        vat.textContent = this.money(Math.round(price / this.data.vatDivisor)) + ' ';
        var suffix = document.createElement('span'); suffix.textContent = 'excl. VAT'; vat.appendChild(suffix);
      }
      var sku = this.querySelector('[data-sp-sku]');
      if (sku) { sku.hidden = !(variant && variant.sku); sku.textContent = variant && variant.sku ? 'SKU: ' + variant.sku : ''; }
      this.syncBarcode(variant);
      if (this.add) {
        this.add.disabled = !variant || !variant.available || !validPlan || !!this.posting || !!this.updating;
        this.add.querySelector('[data-sp-add-label]').textContent = !variant ? 'Unavailable combination' : !validPlan ? 'Choose a purchase option' : !variant.available ? 'Sold out' : 'Add to basket';
      }
      var payment = this.form.querySelector('[data-sp-payment]');
      if (payment) payment.hidden = !variant || !variant.available || !validPlan || !!this.updating;
      if (variant) {
        var rule = variant.quantity_rule || {min:1,increment:1};
        this.quantity.min = rule.min || 1;
        this.quantity.step = rule.increment || 1;
        if (rule.max) this.quantity.max = rule.max; else this.quantity.removeAttribute('max');
        var number = Number(this.quantity.value), min = Number(this.quantity.min), step = Number(this.quantity.step);
        if (!Number.isInteger(number) || number < min || (number - min) % step || (rule.max && number > rule.max)) this.quantity.value = min;
        this.form.querySelector('[data-sp-quantity-help]').textContent = [min > 1 ? 'Minimum ' + min + '.' : '', step > 1 ? 'Order in multiples of ' + step + '.' : '', rule.max ? 'Maximum ' + rule.max + '.' : ''].filter(Boolean).join(' ');
        if (variant.media_id) this.showMedia(variant.media_id);
      }
      this.updateQuantity();
      if (updateUrl && !(window.Shopify && window.Shopify.designMode)) {
        var url = new URL(window.location.href);
        url.searchParams.delete('option_values');
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
      }
      if (window.SerlexFulfilment && this.data.needsConfirmation) window.SerlexFulfilment.register(this.data, this.form);
      this.dispatchEvent(new CustomEvent('serlex:variant-change', {bubbles:true,detail:{variant:variant || null}}));
    }
    syncBarcode(variant) {
      var panel = this.querySelector('[data-sp-barcode]');
      if (!panel) return;
      // Keep the barcode as a string: leading zeroes are part of its value.
      var value = variant && variant.barcode != null ? String(variant.barcode) : '';
      var dialog = panel.querySelector('[data-sp-barcode-dialog]');
      if (dialog.open && dialog.close) dialog.close();
      panel.hidden = !value.trim();
      panel.querySelectorAll('[data-sp-barcode-value]').forEach(node => { node.textContent = value; });
      var holder = panel.querySelector('[data-sp-barcode-image]');
      var enlarge = panel.querySelector('[data-sp-barcode-open]');
      holder.hidden = true; enlarge.hidden = true;
      panel.querySelectorAll('svg').forEach(svg => { svg.replaceChildren(); });
      if (panel.hidden) return;
      var note = panel.querySelector('[data-sp-barcode-note]');
      note.textContent = 'Barcode value (scan image unavailable)';
      if (typeof window.JsBarcode !== 'function' || !/^[\x20-\x7E]+$/.test(value)) return;
      try {
        holder.hidden = false;
        this.drawBarcodes();
        enlarge.hidden = typeof dialog.showModal !== 'function';
        note.textContent = 'Scan for the selected option';
      } catch (_) {
        // Invalid values must never leave the previous variant's bars visible.
        panel.querySelectorAll('svg').forEach(svg => { svg.replaceChildren(); });
        holder.hidden = true;
      }
    }
    drawBarcodes() {
      var panel = this.querySelector('[data-sp-barcode]');
      if (!panel || panel.hidden || panel.querySelector('[data-sp-barcode-image]').hidden || typeof window.JsBarcode !== 'function') return;
      var value = this.variant && this.variant.barcode != null ? String(this.variant.barcode) : '';
      if (!/^[\x20-\x7E]+$/.test(value)) return;
      var encoded = {};
      window.JsBarcode(encoded, value, {format:'CODE128'});
      var modules = encoded.encodings.reduce((count, encoding) => count + encoding.data.length, 0);
      panel.querySelectorAll('svg').forEach(svg => {
        var large = svg.hasAttribute('data-sp-barcode-large');
        if (large && !panel.querySelector('[data-sp-barcode-dialog]').open) return;
        var available = svg.parentElement.clientWidth;
        // Integer module widths and 12-module quiet zones prevent narrow-screen
        // CSS scaling from changing the pattern that a scanner reads.
        var width = Math.max(1, Math.min(large ? 6 : 2, Math.floor(available / (modules + 24))));
        window.JsBarcode(svg, value, {format:'CODE128',width:width,height:large ? 110 : 70,displayValue:false,background:'#ffffff',lineColor:'#000000',margin:10,marginLeft:12 * width,marginRight:12 * width});
        svg.setAttribute('viewBox', '0 0 ' + parseFloat(svg.getAttribute('width')) + ' ' + parseFloat(svg.getAttribute('height')));
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        svg.setAttribute('aria-label', 'Barcode ' + value);
      });
    }
    updateQuantity() {
      var count = Number(this.quantity.value), min = Number(this.quantity.min) || 1, max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      this.form.querySelector('[data-sp-quantity="-1"]').disabled = count <= min;
      this.form.querySelector('[data-sp-quantity="1"]').disabled = count >= max;
      var main = this.form.querySelector('[data-sp-bundle-main]');
      if (main) { main.id = this.variant ? this.variant.id : ''; main.value = count; }
      var total = this.variant ? this.variant.price * count : 0, addons = 0;
      this.form.querySelectorAll('[data-sp-addon-card]').forEach(card => {
        var select = card.querySelector('[data-sp-addon]'), option = select.options[select.selectedIndex];
        var field = card.querySelector('.field'); field.id = select.value; field.value = count;
        if (card.querySelector('[data-sp-addon-check]').checked) { total += Number(option.dataset.price) * count; addons++; }
      });
      var output = this.form.querySelector('[data-sp-bundle-total]');
      if (output) { output.hidden = !addons; output.textContent = 'Selected items total: ' + this.money(total); }
    }
    showMedia(id) {
      var media = this.querySelector('[data-sp-media="' + id + '"]');
      if (!media) return;
      this.querySelectorAll('[data-sp-media]').forEach(item => {
        var hide = item !== media;
        if (hide && !item.hidden) {
          item.querySelectorAll('video').forEach(video => video.pause());
          item.querySelectorAll('iframe').forEach(frame => { var src = frame.getAttribute('src'); frame.setAttribute('src', src); });
          item.querySelectorAll('model-viewer').forEach(model => { if (model.pause) model.pause(); });
        }
        item.hidden = hide;
      });
      this.querySelectorAll('[data-sp-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.spThumbnail === String(id))));
    }
    async fetchSelection() {
      if (this.variantAbort) this.variantAbort.abort();
      this.syncBarcode(null);
      this.variantAbort = new AbortController();
      var controller = this.variantAbort;
      var values = Array.from(this.form.querySelectorAll('[data-sp-option-select]')).map(select => select.selectedOptions[0].dataset.valueId);
      if (values.some(value => !value)) { this.status('Please choose your option using the product-option list.', true); this.classList.remove('sp-enhanced'); return; }
      var url = new URL(window.location.href);
      url.searchParams.delete('variant'); url.searchParams.set('option_values', values.join(',')); url.searchParams.set('section_id', this.data.sectionId);
      this.updating = true;
      if (this.add) this.add.disabled = true;
      var payment = this.form.querySelector('[data-sp-payment]'); if (payment) payment.hidden = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status('Updating your selection…');
      var focus = document.activeElement;
      var focusIndex = focus && (focus.dataset.optionIndex || focus.dataset.spOptionSelect);
      var focusValue = focus && focus.dataset.spChoice;
      var quantity = this.quantity.value;
      var oldPlan = this.form.querySelector('[data-sp-plan]');
      var selectedPlan = oldPlan && oldPlan.value;
      try {
        var response = await fetch(url, {signal:controller.signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
        if (!response.ok) throw new Error('Options could not be updated.');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var buy = doc.querySelector('serlex-product[data-product-id="' + this.data.id + '"] [data-sp-buy]');
        if (!buy || !buy.querySelector('[data-sp-product]')) throw new Error('Options could not be updated.');
        if (controller.signal.aborted || !this.isConnected) return;
        this.querySelector('[data-sp-buy]').replaceWith(buy);
        this.updating = false;
        this.bindBuy();
        this.quantity.value = quantity;
        var newPlan = this.form.querySelector('[data-sp-plan]');
        if (newPlan && selectedPlan !== null) newPlan.value = selectedPlan;
        this.syncVariant(this.variant, true);
        var nextFocus = Array.from(this.form.querySelectorAll('[data-sp-choice], [data-sp-option-select]')).find(el => focusValue ? el.dataset.optionIndex === focusIndex && el.dataset.spChoice === focusValue : el.dataset.spOptionSelect === focusIndex);
        if (nextFocus) nextFocus.focus({preventScroll:true});
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.updating = false;
        // Never leave the old variant purchasable after a failed option request.
        this.variant = null; this.master.value = '';
        this.status('We could not update those options. Please try again or reload this page.', true);
      } finally { if (controller === this.variantAbort) this.form.removeAttribute('aria-busy'); }
    }
    history() {
      var id = new URL(window.location.href).searchParams.get('variant');
      var variant = this.data.variants.find(v => String(v.id) === String(id || this.data.selectedId));
      if (variant) this.syncVariant(variant, false);
      else if (!this.data.complete) window.location.reload();
    }
    async submit(event) {
      if (event.target !== this.form || !this.add) return;
      event.preventDefault();
      if (this.posting || this.updating || !this.variant || !this.variant.available || this.add.disabled || !this.form.reportValidity()) return;
      // The document-level fulfilment guard runs first, including for keyboard submits.
      if ((this.data.needsConfirmation || this.form.querySelector('[data-serlex-fulfilment]')) && !window.SerlexFulfilment) { this.status('The collection check is still loading. Please try again in a moment.', true); return; }
      this.posting = true;
      this.add.disabled = true;
      this.add.setAttribute('aria-busy', 'true');
      this.add.querySelector('[data-sp-add-label]').textContent = 'Adding…';
      this.status('');
      var body = new FormData(this.form);
      var extras = Array.from(this.form.querySelectorAll('[data-sp-addon-card]')).filter(card => card.querySelector('[data-sp-addon-check]').checked);
      var options = {method:'POST',headers:{Accept:'application/json'},body:body};
      if (extras.length) {
        var properties = {};
        body.forEach((value, key) => { var match = key.match(/^properties\[(.+)\]$/); if (match && typeof value === 'string') properties[match[1]] = value; });
        var main = {id:this.variant.id,quantity:Number(this.quantity.value),properties:properties};
        if (body.get('selling_plan')) main.selling_plan = body.get('selling_plan');
        var items = [main].concat(extras.map(card => ({id:Number(card.querySelector('[data-sp-addon]').value),quantity:Number(this.quantity.value)})));
        options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify({items:items});
      }
      try {
        var response = await fetch(this.root() + 'cart/add.js', options);
        var result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please check the options and quantity.');
        this.status('Added to your basket.', false, true);
        // Refresh the existing theme's count, totals and mini basket without another add request.
        try {
          var cartResponse = await fetch(this.root() + 'cart.js', {headers:{Accept:'application/json'}});
          if (!cartResponse.ok) throw new Error('Basket refresh failed');
          var cart = await cartResponse.json();
          if (typeof window.updateCartDesc === 'function') window.updateCartDesc(cart);
          if (window.Shopify && typeof window.Shopify.updateCartInfo === 'function') window.Shopify.updateCartInfo(cart, '#cart-info #cart-content');
          document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:cart}}));
        } catch (_) { this.status('Added to your basket. Open your basket to see the latest total.', false, true); }
      } catch (error) {
        this.status(error instanceof TypeError ? 'We could not confirm that this item was added. Check your basket before trying again.' : error.message || 'This item could not be added. Please try again.', true, true);
      } finally {
        this.posting = false;
        if (this.isConnected) { this.add.removeAttribute('aria-busy'); this.syncVariant(this.variant, false); }
      }
    }
    async loadRelated() {
      var below = this.querySelector('[data-sp-related-below]');
      if (this.dataset.related !== 'true' && (!below || below.dataset.mode !== 'automatic')) return;
      var limit = Math.max(2, Math.min(18, Number(this.dataset.relatedLimit) || 8));
      var template = this.querySelector('[data-sp-fallback]');
      var fallback = template ? Array.from(template.content.querySelectorAll('.sp-related-card')) : [];
      var merge = cards => {
        var seen = new Set([String(this.data.id)]);
        return cards.concat(fallback).filter(card => {
          var id = card.dataset.id;
          if (!id || seen.has(id)) return false;
          seen.add(id); return true;
        }).slice(0, limit);
      };
      // Render the server-built department/catalogue fallback immediately.
      this.displayRelated(merge([]), below);
      this.startRelatedRails();
      var cards = [];
      this.relatedAbort = new AbortController();
      var controller = this.relatedAbort;
      this.relatedTimeout = window.setTimeout(() => controller.abort(), 6000);
      try {
        var response = await fetch(this.root() + 'recommendations/products.json?product_id=' + encodeURIComponent(this.data.id) + '&limit=' + Math.min(10, limit) + '&intent=related', {signal:controller.signal});
        if (!response.ok) throw new Error('Recommendations unavailable');
        var data = await response.json();
        var ids = new Set([String(this.data.id)]);
        (data.products || []).forEach(product => {
          if (!product.id || ids.has(String(product.id)) || product.available === false || cards.length >= limit || !product.url) return;
          var url = new URL(product.url, window.location.origin);
          if (url.origin !== window.location.origin) return;
          ids.add(String(product.id));
          var card = document.createElement('a'); card.className = 'sp-related-card'; card.href = url.href; card.dataset.id = product.id;
          var source = product.featured_image || (product.images && product.images[0]);
          if (source && typeof source === 'object') source = source.src || source.url;
          if (source) {
            var imageUrl = new URL(source, window.location.origin);
            if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
              imageUrl.searchParams.set('width','450');
              var image = document.createElement('img'); image.src = imageUrl.href; image.alt = product.title; image.width = 450; image.height = 450; image.loading = 'lazy'; card.appendChild(image);
            }
          }
          if (!card.querySelector('img')) {
            var placeholder = document.createElement('span'); placeholder.className = 'sp-related-placeholder'; placeholder.setAttribute('aria-hidden', 'true'); card.appendChild(placeholder);
          }
          if (product.vendor) { var vendor = document.createElement('span'); vendor.className = 'sp-card-vendor'; vendor.textContent = product.vendor; card.appendChild(vendor); }
          var title = document.createElement('span'); title.className = 'sp-related-title'; title.textContent = product.title; card.appendChild(title);
          var price = document.createElement('span'); price.className = 'sp-related-price'; price.textContent = (product.price_varies ? 'From ' : '') + this.money(product.price) + ' ';
          var arrow = document.createElement('span'); arrow.setAttribute('aria-hidden','true'); arrow.textContent = '↗'; price.appendChild(arrow); card.appendChild(price);
          cards.push(card);
        });
      } catch (_) { /* The visible fallback also covers empty, slow or failed API responses. */ }
      finally { clearTimeout(this.relatedTimeout); }
      if (this.isConnected && this.relatedAbort === controller) this.displayRelated(merge(cards), below);
    }
    displayRelated(cards, below) {
      this.dataset.hasRelated = String(cards.length > 0);
      if (below && below.dataset.mode === 'automatic') {
        below.querySelector('[data-sp-below-list]').replaceChildren(...cards.map(card => card.cloneNode(true)));
        below.hidden = !cards.length;
      }
      this.querySelectorAll('[data-sp-rail]').forEach((rail, index) => {
        var items = cards.length === 1 ? cards : cards.filter((_, i) => i % 2 === index);
        rail.querySelector('[data-sp-rail-list]').replaceChildren(...items.map(card => card.cloneNode(true)));
        rail.hidden = !items.length;
        if (!rail.dataset.paused) this.pauseRail(rail, this.dataset.roll !== 'true' || this.reduce.matches || !!(window.Shopify && window.Shopify.designMode));
      });
    }
    startRelatedRails() {
      var rails = Array.from(this.querySelectorAll('[data-sp-rail]'));
      if (!rails.length) return;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { entries.forEach(entry => { entry.target.dataset.visible = String(entry.isIntersecting); }); });
        rails.forEach(rail => this.observer.observe(rail));
      }
      this.motion();
      this.railTimer = window.setInterval(() => {
        if (!this.wide.matches || this.reduce.matches || document.hidden || (window.Shopify && window.Shopify.designMode)) return;
        rails.forEach(rail => {
          if (!rail.hidden && rail.dataset.visible === 'true' && rail.dataset.paused !== 'true' && !rail.matches(':hover') && !rail.contains(document.activeElement)) this.advanceRail(rail, 1);
        });
      }, Math.max(5, Number(this.dataset.interval) || 8) * 1000);
    }
    pauseRail(rail, paused) {
      rail.dataset.paused = String(paused);
      var button = rail.querySelector('[data-sp-rail-pause]');
      button.setAttribute('aria-pressed', String(paused)); button.textContent = paused ? 'Play' : 'Pause';
      button.setAttribute('aria-label', paused ? 'Play related-item scrolling' : 'Pause related-item scrolling');
    }
    motion() {
      this.querySelectorAll('[data-sp-rail-pause]').forEach(button => { button.hidden = this.reduce.matches || !!(window.Shopify && window.Shopify.designMode); });
    }
    advanceRail(rail, direction) {
      var list = rail.querySelector('[data-sp-rail-list]');
      if (list.scrollHeight <= list.clientHeight + 2) return;
      var step = list.firstElementChild ? list.firstElementChild.getBoundingClientRect().height + 15 : 180;
      var end = list.scrollHeight - list.clientHeight;
      var top = direction > 0 && list.scrollTop >= end - 3 ? 0 : direction < 0 && list.scrollTop <= 1 ? end : Math.max(0, Math.min(end, list.scrollTop + step * direction));
      list.scrollTo({top:top,behavior:this.reduce.matches ? 'auto' : 'smooth'});
    }
  }
  customElements.define('serlex-product', SerlexProduct);
})();
